import { motion } from "framer-motion";

const ease = [0.16, 1, 0.3, 1];
const IMG = "/img/training.jpg";

const STEPS = [
  { n: "01", t: "Diagnostiquer", d: "Comprendre vos risques réels, sur le terrain et dans vos documents." },
  { n: "02", t: "Former", d: "Donner à chaque équipe les réflexes qui sauvent des vies." },
  { n: "03", t: "Transformer", d: "Installer une culture sécurité mesurable, durable, partagée." },
];

export const Approach = () => (
  <section id="approche" className="relative bg-white py-24 lg:py-32 overflow-hidden" data-testid="approach-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 grid lg:grid-cols-12 gap-12 items-center">
      <motion.div
        initial={{ opacity: 0, x: -40 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 1, ease }}
        className="lg:col-span-5 relative"
      >
        <div className="relative aspect-[4/5] rounded-[2.5rem] rounded-bl-[8rem] overflow-hidden">
          <img src={IMG} alt="Formation sécurité d'équipes africaines sur chantier" className="absolute inset-0 w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-tr from-forest/60 to-transparent" />
        </div>
        <div className="absolute -right-6 -bottom-6 bg-african text-white rounded-3xl px-6 py-5 shadow-xl rotate-[-3deg]">
          <div className="font-accent text-xs tracking-[0.25em] uppercase">Abidjan · Afrique</div>
          <div className="font-heading font-extrabold text-2xl mt-1">Impact durable</div>
        </div>
      </motion.div>

      <div className="lg:col-span-7 lg:pl-8">
        <p className="eyebrow mb-5">Notre approche</p>
        <h2 className="font-heading font-extrabold text-forest text-3xl sm:text-4xl lg:text-5xl leading-[1.02] tracking-tight">
          Solutions innovantes pour l'HSE. <span className="font-accent font-normal text-safety">Expertise et accompagnement.</span>
        </h2>
        <p className="mt-6 text-ink/65 text-base leading-relaxed max-w-xl">
          RisQZero combine rigueur normative et connaissance intime des réalités africaines : chantiers isolés, chaleur, sous-traitance, informalité. Nos solutions sont pensées pour fonctionner là où vous travaillez vraiment.
        </p>
        <ol className="mt-12 space-y-0 divide-y divide-forest/10">
          {STEPS.map((s, i) => (
            <motion.li
              key={s.n}
              initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8, delay: i * 0.12, ease }}
              className="group grid grid-cols-[4rem_1fr] gap-4 py-6 items-start"
              data-testid={`approach-step-${i + 1}`}
            >
              <span className="font-accent text-2xl text-african group-hover:translate-x-1 transition-transform">{s.n}</span>
              <div>
                <h3 className="font-heading font-bold text-xl text-forest">{s.t}</h3>
                <p className="mt-1 text-ink/60 text-sm">{s.d}</p>
              </div>
            </motion.li>
          ))}
        </ol>
      </div>
    </div>
  </section>
);
